/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  CreateJobTemplateRequestBody,
  CreateJobTemplateResponse,
  GetJobTemplateResponse,
  GetJobTemplatesParams,
  GetJobTemplatesResponse,
  UpdateJobTemplateRequestBody,
  UpdateJobTemplateResponse
} from '../model';

import postJobTemplateMutator from '../../../mutators/datastore-instance';
import getJobTemplatesMutator from '../../../mutators/datastore-instance';
import putJobTemplateMutator from '../../../mutators/datastore-instance';
import getJobTemplateMutator from '../../../mutators/datastore-instance';
import deleteJobTemplateMutator from '../../../mutators/datastore-instance';



  /**
 * JobTemplateを新規作成する
 * @summary JobTemplateを新規作成
 */
export const postJobTemplate = (
    createJobTemplateRequestBody?: CreateJobTemplateRequestBody,
 ) => {
      return postJobTemplateMutator<CreateJobTemplateResponse>(
      {url: `/job-templates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createJobTemplateRequestBody
    },
      );
    }
  /**
 * JobTemplateの一覧・検索をする
 * @summary JobTemplateの一覧・検索取得
 */
export const getJobTemplates = (
    params?: GetJobTemplatesParams,
 ) => {
      return getJobTemplatesMutator<GetJobTemplatesResponse>(
      {url: `/job-templates`, method: 'GET',
        params
    },
      );
    }
  /**
 * JobTemplateを更新する
 * @summary JobTemplateを更新
 */
export const putJobTemplate = (
    jobTemplateId: number,
    updateJobTemplateRequestBody?: UpdateJobTemplateRequestBody,
 ) => {
      return putJobTemplateMutator<UpdateJobTemplateResponse>(
      {url: `/job-templates/${jobTemplateId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateJobTemplateRequestBody
    },
      );
    }
  /**
 * JobTemplateの詳細を取得する
 * @summary JobTemplateの詳細取得
 */
export const getJobTemplate = (
    jobTemplateId: number,
 ) => {
      return getJobTemplateMutator<GetJobTemplateResponse>(
      {url: `/job-templates/${jobTemplateId}`, method: 'GET'
    },
      );
    }
  /**
 * JobTemplateを削除する
 * @summary JobTemplateの削除
 */
export const deleteJobTemplate = (
    jobTemplateId: number,
 ) => {
      return deleteJobTemplateMutator<void>(
      {url: `/job-templates/${jobTemplateId}`, method: 'DELETE'
    },
      );
    }
  export type PostJobTemplateResult = NonNullable<Awaited<ReturnType<typeof postJobTemplate>>>
export type GetJobTemplatesResult = NonNullable<Awaited<ReturnType<typeof getJobTemplates>>>
export type PutJobTemplateResult = NonNullable<Awaited<ReturnType<typeof putJobTemplate>>>
export type GetJobTemplateResult = NonNullable<Awaited<ReturnType<typeof getJobTemplate>>>
export type DeleteJobTemplateResult = NonNullable<Awaited<ReturnType<typeof deleteJobTemplate>>>
